import React, { useState, useEffect } from 'react';
import Tab from "../components/tab";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import { useSelector, useDispatch } from "react-redux";
import { currentEducation, saveEducation, dispatchEducation } from "../../../Redux/ActionCreator"; // Assuming this action exists
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";


const Education1 = ({nextStep, prevStep, setStep }) => {
  const dispatch = useDispatch();
  const currentEdu = useSelector(state => state.currentEducation); // Redux state for current education
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const secret = useSelector(e => e.secret);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const [school, setSchool] = useState([
    "No Formal Education",
    "Primary Education",
    "Secondary Education",
    "High School Diploma",
    "Certification",
    "Vocational/Technical Training",
    "Some College",
    "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "PHD",
    "Other"
  ]);

  const [ selectedDegree, setSelectedDegree ] = useState("");
  const [ other, setOther ] = useState("");
  // const [ degreeState, setDegreeState ] = useState("")

  const handleNoEducation = async () => {
    setSelectedDegree("No Formal Education");
    let educationData = {
      School: null,
      // Where_i_worked_location: $('[name="work_place"]').val(),
      Degree: "No Formal Education",
      Course: null,
      End_date: null,
    }
    dispatch(currentEducation(educationData));
    dispatch(dispatchEducation([educationData]));
    dispatch(saveEducation(educationData, secret));
    // save into server cache
    await saveIntoServerCache("current_education", educationData);
    setStep(21);
  }

  const [showHeading1, setShowHeading1] = useState(false);
  const [showHeading2, setShowHeading2] = useState(false);

  // Prefill fields from Redux or fetch from Redis
  useEffect(() => {
    if (currentEdu.message !== null) {
      setSelectedDegree(currentEdu.message.Degree || "");
      setOther(currentEdu.message.other || "");
    } else {
      getOneFromServerCache("current_education")
        .then(res => res.json())
        .then(res => {
          if (res.success && res.data) {
            const eduData = JSON.parse(res.data);
            dispatch(currentEducation(eduData));
            setSelectedDegree(eduData?.Degree || "");
            setOther(eduData?.other || "");
          }
        })
        .catch(error => console.log("Error prefilling education data", error));
    }
  }, [dispatch]);

  useEffect(() => {
    // Show first name label and input after delay (simulating onDone)
    const showHeading1Timeout = setTimeout(() => setShowHeading1(true), 1000); // Matches Typewriter speed

    return () => clearTimeout(showHeading1Timeout);
  }, []);

  useEffect(() => {
    if (showHeading1 == true) {
      // Show last name label and input once first name is being typed
      const showHeading2Timeout = setTimeout(() => setShowHeading2(true), 800);

      return () => clearTimeout(showHeading2Timeout);
    }
  }, [showHeading1]); // Runs only when firstName updates

  const handleSchoolChange = (e) => {
    setSelectedDegree(e);
    const educationData = { Degree: e, other: other || "" };
    dispatch(currentEducation(educationData));
    saveIntoServerCache("current_education", educationData); // Save to cache
  };

  const handleOtherChange = (e) => {
    setOther(e.target.value);
    const educationData = { highestDegree: selectedDegree, other: e.target.value };
    dispatch(currentEducation(educationData));
    saveIntoServerCache("current_education", educationData); // Save to cache
  };

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    try {
      if (selectedDegree !== "") {
        let educationData = {
          School: currentEdu.message.School?.trim() || null,
          // Where_i_worked_location: $('[name="work_place"]').val(),
          Degree: selectedDegree?.trim(),
          Course: currentEdu.message?.Course || null,
          End_date: selectedDegree == "No Formal Education" ? null : currentEdu.message?.End_date,
        }
        dispatch(currentEducation(educationData));
        // save into server cache
        await saveIntoServerCache("current_education", educationData);
        nextStep();
      }
    } catch (error) {
        throw error
    }
  }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-center items-center mb-4">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <Tab num="3" current={false} label="Language" completed={true} />
            <Tab num="4" current={true} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>


        <div className="flex justify-center w-full">
          <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
            <h2 className="text-xl text-[#5843BD] font-semibold mb-2 notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Agreguemos los detalles de tu educación."]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Let's add your education details"]} loop={1} typeSpeed={40} />
              )}
              </h2>
                {/* <Typewriter words={["Let's add your education details"]} loop={1} typeSpeed={40} /></h2> */}
           {showHeading1 && (
             <p className='notranslate'>
                {flowLanguage == "Spanish" ? (
                  <Typewriter key={flowLanguage} words={["¿Cuál es el nivel más alto de educación que has completado?"]} loop={1} typeSpeed={40} />
                ) : (
                  <Typewriter key={flowLanguage} words={["What is the highest level of eduaction you've completed?"]} loop={1} typeSpeed={40} />
                )}
                {/* <Typewriter words={["What is the highest level of eduaction you've completed?"]} loop={1} typeSpeed={40} /> */}
            </p>
           )}
            
            {showHeading2 && (
                <motion.div 
                    initial={{ opacity: 0, y: 30 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
                    className="md:flex items-center justify-center vsm:flex-wrap w-full max-w-[600px]"
                >
                    <FormControl fullWidth
                        sx={{
                        // Style the outer input border:
                        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                            borderColor: "orange"
                        },
                        // When focused:
                        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "orange"
                        }
                        }}
                    >
                      {selectedDegree == "" ? <InputLabel className='notranslate' key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "Selecciona tu grado más alto."
                        ) : (
                          "Select your highest degree"
                        )}                      
                      </InputLabel> : null}
                        
                        <Select
                        value={selectedDegree}
                        onChange={(e) => handleSchoolChange(e.target.value)}
                        sx={{
                            backgroundColor: selectedDegree ? "#FF6633" : "transparent",
                            color: selectedDegree ? "white" : "black",
                            borderRadius: "10px",
                            padding: "6px 12px", // Adjust padding to match the input field
                            maxHeight: "45px", // Ensure consistent height with the input field
                            fontSize: "16px", // Adjust font size if needed
                            // Style focus state:
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FF6633",
                            },
                            "&.Mui-focused": {
                                backgroundColor: "#FF6633",
                                color: "white"
                            },
                            "& .MuiSelect-icon": {
                              color: selectedDegree ? "white" : "black", // Set icon color
                            },

                        }}
                        >
                        {school.map((school, idx) => (
                            <MenuItem 
                            key={idx} 
                            value={school} 
                            sx={{
                                // Hover styles:
                                "&:hover": {
                                backgroundColor: "#FF6633",
                                color: "#fff"
                                }
                            }}
                            >
                            {school}
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>

                    {selectedDegree == "Other" ? (
                        <input
                        type="text"
                        className="w-full border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent my-6"
                        placeholder="type your language here"
                        value={other}
                        onChange={handleOtherChange}
                    />
                    ) : null} 
                </motion.div>
            )}

            <motion.p 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }} className='text-[#5843BD] font-semibold text-base text-center my-6 underline cursor-pointer notranslate' onClick={handleNoEducation}  key={flowLanguage}><em>
                  {flowLanguage == "Spanish" ? (
                    "Si no asististe a la escuela, haz clic aquí."
                  ) : (
                    "If you didn't go to school, click here"
                  )}
                  
                </em>
            </motion.p>
          </div>
        </div>


        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 4.5 }}
            className="flex justify-between lg:max-w-[90%] w-full">
            <div className="flex justify-center w-full">
              <div className="flex justify-between lg:max-w-[90%] w-full">
                <button
                    onClick={handlePrev}
                    className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md"
                >
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                </button>
                
                <button
                    onClick={handleNextCall}
                    className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md"
                >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GUARDAR"
                    ) : (
                      "SAVE"
                    )}
                  </span>
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>

              </div>
            </div>
          </motion.div>
        </div>
        

      </div>
    </div>
  );
};

export default Education1;
